import { useQuery } from '@tanstack/react-query';

import { getOrganizationUsers } from '../services/individualBioService';
import { UserToOrganization } from '../types';

export const useOrganizationUsers = () => {
  const { data, isLoading, error } = useQuery<UserToOrganization[], Error>({
    queryKey: ['organizationUsers'],
    queryFn: getOrganizationUsers,
    staleTime: 1000 * 60 * 10, // 10 minutes - organization users don't change frequently
  });

  return {
    users: data || [],
    loading: isLoading,
    error: error?.message || null,
  };
};
